import { useContext } from "react";

import { APIContext, type APIContextState } from "../../contexts";

/**
 * Provides the API context.
 * @returns The API context.
 */
export const useAPI = (): APIContextState => {
  const context = useContext(APIContext);
  if (!context) {
    throw new Error("useAPI must be used within an APIProvider");
  }

  return context;
};
